"use client";

import { DataTable } from "@/components/ui/DataTable";
import { Product } from "@/lib/models/product";
import { MapPin } from "lucide-react";
import React from "react";

interface StockProps {
  product?: Partial<Product> | null;
}

const warehouseMap: Record<string, string> = {
  "02": "Ciudad de México",
  "15": "Guadalajara",
  "03": "Monterrey",
};

export function Stock({ product }: StockProps) {
  if (!product) {
    return (
      <div className="p-4 text-center text-slate-500 font-medium">
        Información de stock no disponible.
      </div>
    );
  }

  const sortedWarehouseCodes = Object.keys(warehouseMap).sort((a, b) =>
    warehouseMap[a].localeCompare(warehouseMap[b]),
  );

  const getWarehouseStock = () => {
    return sortedWarehouseCodes.map((code) => {
      const warehouseStock = product?.price?.stockPorAlmacen?.find(
        (w) => w.warehouse === code,
      );
      const catalogStock =
        product?.[`stockWarehouse${code}` as keyof Product] || 0;
      const stockQuantity =
        warehouseStock?.cantidadDisponibleAlmacen ?? Number(catalogStock) ?? 0;

      return {
        id: code,
        name: (
          <div className="flex items-center text-[12px] gap-2">
            <MapPin className="w-4 h-4 text-primary shrink-0" />
            <span>{warehouseMap[code]}</span>
          </div>
        ),
        cantidadDisponibleAlmacen: (
          <p className="text-center text-[12px]">{stockQuantity}</p>
        ),
      };
    });
  };

  const totalStock =
    product?.price?.stockDisponibleTotal ??
    product?.stockDisponibleTotal ??
    product?.stockTotal ??
    0;

  return (
    <div className="space-y-4">
      <div className="flex flex-col">
        <div className="p-1 bg-blue-50 dark:bg-blue-900/30 rounded-lg mb-2 flex justify-between items-center ">
          <p className="text-[12px] font-medium text-secondary">
            Stock Total :
          </p>
          <p className="px-1.5 py-0 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 rounded-md text-[12px] font-medium">
            {totalStock}
          </p>
        </div>
        <div className="border rounded-lg overflow-hidden">
          <DataTable
            headers={[
              { title: "Sucursal", key: "name", style: "text-[12px]" },
              {
                title: "En sucursal",
                key: "cantidadDisponibleAlmacen",
                style: "text-center text-[12px]",
              },
            ]}
            content={getWarehouseStock()}
          />
        </div>
      </div>
    </div>
  );
}
